import { getBannerConfig } from './urls'
import Axios from 'axios'

const debug = process.env.NODE_ENV !== 'production'

export function getBanner(param: any) {
  return Axios.get(
    debug ? getBannerConfig : `//banner.api.mgtv.com${getBannerConfig}`,
    {
      params: {
        ...param,
      },
    }
  )
}
